var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 0.75C6.10523 0.75 4.56523 2.29 4.56523 4.185C4.56523 6.075 6.10523 7.615 8.00023 7.615C9.89523 7.615 11.4352 6.075 11.4352 4.185C11.4352 2.29 9.89523 0.75 8.00023 0.75ZM14.1852 12.93C13.8102 10.37 11.5802 8.44 8.99023 8.44H7.01023C4.42023 8.44 2.19023 10.37 1.81523 12.93L1.62023 14.245C1.55023 14.75 1.69523 15.26 2.03023 15.645C2.36023 16.03 2.84523 16.25 3.35523 16.25H12.6452C13.1552 16.25 13.6402 16.03 13.9702 15.645C14.3052 15.26 14.4502 14.75 14.3802 14.245L14.1852 12.93Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_2349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.10c73452ba2dbe2f61453e0bffb80212.svg";
export { ForwardRef as ReactComponent };